import React, { useEffect, useState, useRef } from 'react';
import Typography from '@mui/material/Typography';
import { useMediaQuery } from 'react-responsive';
import Grid from '@mui/material/Grid';
import LoupeItemHeaderComponent from './LoupeItemHeaderComponent';
import { Box, RangeSelector, Stack, Text } from 'grommet';
import { LocalizationContext } from '../../App';


const LoupeNumericRangeSelectionComponent = (props) => {

    const currentItem = props.currentItem;
    const [ rangedValues, setRangedValues ] = React.useState( currentItem.selectedValues );
 
    const handleRangeValueChanged = nextValues => {
        currentItem.selectedValues = nextValues;
        currentItem.validator.touched();

        if(currentItem.validator.instantRevalidation) {
            currentItem.validator.revalidate();
        }

        setRangedValues(nextValues);
    }

   

    return(

        <LocalizationContext.Consumer>
            { ({strings}) => 

                <div className="text-start mb-4">

                    <LoupeItemHeaderComponent currentItem={currentItem} />

                    <Stack>
                        <Box direction='row' justify='between'>
                            { currentItem.scales.map(value => (
                            <Box key={value} pad='small' border={false}>
                                <Text style={{ fontFamily: 'monospace' }}>{value}</Text>
                            </Box>
                            ))}
                        </Box>

                        <RangeSelector
                            color="#e3165b"
                            direction='horizontal'
                            invert={false}
                            min={currentItem.minValue}
                            max={currentItem.maxValue}
                            size='full'
                            round='small'
                            values={rangedValues}
                            onChange={nextValues => handleRangeValueChanged(nextValues)}
                        />

                    </Stack>


                </div>
            }
        </LocalizationContext.Consumer>

    );

}
export default LoupeNumericRangeSelectionComponent;